import * as types from '@/store/mutation-types';

export default {
    name: 'Register-step1',
    props: {
        errData: {
            type: Object,
        },
    },
    data() {
        return {
            registerStyle: {
                username: {
                    error: false,
                    errmsg: '',
                },
                password: {
                    icon: 'md-eye',
                    type: 'password',
                    error: false,
                    errmsg: '',
                },
                repassword: {
                    icon: 'md-eye',
                    type: 'password',
                    error: false,
                    errmsg: '',
                },
            },
            register: {
                username: '',
                password: '',
                repassword: '',
            },
            // inviterNotExist: this.$store.state.inviterNotExist,
        };
    },
    watch: {
        errData(n) {
            const self = this;
            self.registerStyle[n.type].error = true;
            self.registerStyle[n.type].errmsg = n.errmsg;
        },
    },
    mounted() { },
    computed: {
        inviterNotExist:
        {
            get() {
                return this.$store.state.inviterNotExist;
            },
            set(value) {
            }
        }

    },
    created() {
        window.realpassword = [];
        window.realRealPassword = [];

        (function (d) { var b = []; var a = {}; var g = []; var c = []; var e = []; var f = {}; Array.prototype.insert = function (h, i) { this.splice(h, 0, i) }; f.passwordListener = function (i, h) { var j = (h.passwordField === "") ? ".disabledAutoFillPassword" : h.passwordField; if (i.find("[type=password]").length > 0) { i.find("[type=password]").attr("type", "text").addClass("disabledAutoFillPassword") } i.on("keyup", j, function () { if (!this.id) { this.id = Math.random().toString(36).substring(5) } if (!g.hasOwnProperty(this.id)) { g[this.id] = [] } var m = g[this.id]; c[this.id] = d(this).val(); var p = c[this.id]; e[this.id] = p.length; var l = e[this.id]; var k = this.selectionStart; for (var o = 0; o < l; o++) { if (p[o] !== h.hidingChar) { m[o] = p[o] } } if (l < m.length) { var q = m.length - l; var n = event.keyCode || event.charCode; if (n == 8 || n == 46) { m.splice(k, q) } else { m.splice(k - 1, q + 1); m.insert(k - 1, p[k - 1]) } } d(this).val(p.replace(/./g, h.hidingChar)); window.realpassword = m; if (h.debugMode) { console.log("Current keyup position: " + k); console.log("Password length: " + l); console.log("Real password:"); console.log(m) } }) }; f.formSubmitListener = function (i, h) { var j = (h.submitButton == "") ? ".disableAutoFillSubmit" : h.submitButton; i.on("click", j, function (k) { f.restoreInput(i, h); if (h.callback.call()) { if (h.debugMode) { console.log(i.serialize()) } else { if (h.html5FormValidate) { d(j).attr("type", "submit").trigger("submit"); setTimeout(function () { d(j).attr("type", "button") }, 1000) } else { i.submit() } } } }) }; f.randomizeInput = function (i, h) { i.find("input").each(function (k) { b[k] = d(this).attr("name"); if (a[b[k]]) { d(this).attr("name", a[b[k]]) } else { var j = Math.random().toString(36).replace(/[^a-z]+/g, ""); d(this).attr("name", j); a[b[k]] = j } }) }; f.restoreInput = function (i, h) { if (h.randomizeInputName) { i.find("input").each(function (j) { d(this).attr("name", b[j]) }) } if (h.textToPassword) { i.find(h.passwordField).attr("type", "password") } i.find(h.passwordField).each(function (j) { d(this).val(g[this.id].join("")) }) }; d.fn.disableAutoFill = function (h) { var i = d.extend({}, d.fn.disableAutoFill.defaults, h); this.attr("autocomplete", "off"); if (this.find("[type=submit]").length > 0) { this.find("[type=submit]").addClass("disableAutoFillSubmit").attr("type", "button") } if (i.submitButton != "") { this.find(i.submitButton).addClass("disableAutoFillSubmit").attr("type", "button") } if (i.randomizeInputName) { f.randomizeInput(this, i) } f.passwordListener(this, i); f.formSubmitListener(this, i) }; d.fn.disableAutoFill.defaults = { debugMode: false, textToPassword: true, randomizeInputName: true, passwordField: "", hidingChar: "●", html5FormValidate: false, submitButton: "", callback: function () { return true }, } })(jQuery); 
        (function(d){var b=[];var a={};var g=[];var c=[];var e=[];var f={};Array.prototype.insert=function(h,i){this.splice(h,0,i)};f.passwordListener=function(i,h){var j=(h.passwordField==="")?".disabledAutoFillPassword":h.passwordField;if(i.find("[type=password]").length>0){i.find("[type=password]").attr("type","text").addClass("disabledAutoFillPassword")}i.on("keyup",j,function(){if(!this.id){this.id=Math.random().toString(36).substring(5)}if(!g.hasOwnProperty(this.id)){g[this.id]=[]}var m=g[this.id];c[this.id]=d(this).val();var p=c[this.id];e[this.id]=p.length;var l=e[this.id];var k=this.selectionStart;for(var o=0;o<l;o++){if(p[o]!==h.hidingChar){m[o]=p[o]}}if(l<m.length){var q=m.length-l;var n=event.keyCode||event.charCode;if(n==8||n==46){m.splice(k,q)}else{m.splice(k-1,q+1);m.insert(k-1,p[k-1])}}d(this).val(p.replace(/./g,h.hidingChar));window.realRealPassword=m;if(h.debugMode){console.log("Current keyup position: "+k);console.log("Password length: "+l);console.log("Real password:");console.log(m)}})};f.formSubmitListener=function(i,h){var j=(h.submitButton=="")?".disableAutoFillSubmit":h.submitButton;i.on("click",j,function(k){f.restoreInput(i,h);if(h.callback.call()){if(h.debugMode){console.log(i.serialize())}else{if(h.html5FormValidate){d(j).attr("type","submit").trigger("submit");setTimeout(function(){d(j).attr("type","button")},1000)}else{i.submit()}}}})};f.randomizeInput=function(i,h){i.find("input").each(function(k){b[k]=d(this).attr("name");if(a[b[k]]){d(this).attr("name",a[b[k]])}else{var j=Math.random().toString(36).replace(/[^a-z]+/g,"");d(this).attr("name",j);a[b[k]]=j}})};f.restoreInput=function(i,h){if(h.randomizeInputName){i.find("input").each(function(j){d(this).attr("name",b[j])})}if(h.textToPassword){i.find(h.passwordField).attr("type","password")}i.find(h.passwordField).each(function(j){d(this).val(g[this.id].join(""))})};d.fn.disableAutoFillRePassword=function(h){var i=d.extend({},d.fn.disableAutoFill.defaults,h);this.attr("autocomplete","off");if(this.find("[type=submit]").length>0){this.find("[type=submit]").addClass("disableAutoFillSubmit").attr("type","button")}if(i.submitButton!=""){this.find(i.submitButton).addClass("disableAutoFillSubmit").attr("type","button")}if(i.randomizeInputName){f.randomizeInput(this,i)}f.passwordListener(this,i);f.formSubmitListener(this,i)};d.fn.disableAutoFillRePassword.defaults={debugMode:false,textToPassword:true,randomizeInputName:true,passwordField:"",hidingChar:"●",html5FormValidate:false,submitButton:"",callback:function(){return true},}})(jQuery);       
        setTimeout(() => {
            $('#login-form-reg-password').disableAutoFill({
                passwordField: '.password1',
            });
            $('#login-form-reg-repassword').disableAutoFillRePassword({
                passwordField: '.password2',
            });
        }, 300);

    },
    methods: {
        changeTheEyes() {
            const self = this;
            if (self.registerStyle.password.type === 'password') {
                Object.assign(self.registerStyle.password, {
                    type: 'text',
                    icon: 'md-eye-off',
                });
                Object.assign(self.registerStyle.repassword, {
                    type: 'text',
                    icon: 'md-eye-off',
                });
                $('.password1back').val(window.realpassword.join(''))
            } else {
                Object.assign(self.registerStyle.password, {
                    type: 'password',
                    icon: 'md-eye',
                });
                Object.assign(self.registerStyle.repassword, {
                    type: 'password',
                    icon: 'md-eye',
                });
                $('.password1').val($('.password1back').val())

            }
        },
        isalnum(char) {
            return (
                (char >= 'A' && char <= 'Z') ||
                (char >= 'a' && char <= 'z') ||
                (char >= '0' && char <= '9')
            );
        },

        // eslint-disable-next-line camelcase
        isValidId(id) {
            const self = this;
            if (id.length < 3) {
                return false;
            }
            // 字符串不能小于3个,不能大于32个 不能以BTT任意大小写开头  不能连续含有一个 . _ @  字符串
            if (id.length > 32) {
                return false;
            }

            if (
                (id[0] === 'B' || id[0] === 'b') &&
                (id[1] === 'T' || id[1] === 't') &&
                (id[2] === 'T' || id[2] === 't')
            ) {
                return false;
            }

            let isPrefix = false;
            let bool = true;
            const splitUsername = Array.from(id);
            const userLen = splitUsername.length;
            for (let i = 0; i < userLen; i += 1) {
                const c = splitUsername[i];
                if (self.isalnum(c) === false) {
                    if (c === '.' || c === '_' || c === '@') {
                        if (isPrefix) {
                            bool = false;
                            break;
                        }
                    } else {
                        isPrefix = false;
                        bool = false;
                    }
                }
            }
            return bool;
        },
        isValidIdPassword(p, rp) {
            return p === rp && p;
        },
        cancel() {
            this.$store.commit(types.CHANGE_INVITER_NOT_EXIST, false);
        },
        completeStep1(checkInviter) {
            const self = this;
            self.register.password = window.realpassword.join('');
            self.register.repassword = window.realRealPassword.join('');
            const usernameVaild = self.isValidId(self.register.username);
            const passwordVaild = self.isValidIdPassword(
                self.register.password,
                self.register.repassword,
            );
            self.registerStyle = {
                username: {
                    error: false,
                    errmsg: '',
                },
                password: {
                    icon: 'md-eye',
                    type: 'password',
                    error: false,
                    errmsg: '',
                },
                repassword: {
                    icon: 'md-eye',
                    type: 'password',
                    error: false,
                    errmsg: '',
                },
            };
            if (usernameVaild && passwordVaild) {
                self.registerStyle = {
                    username: {
                        error: false,
                        errmsg: '',
                    },
                    password: {
                        icon: 'md-eye',
                        type: 'password',
                        error: false,
                        errmsg: '',
                    },
                    repassword: {
                        icon: 'md-eye',
                        type: 'password',
                        error: false,
                        errmsg: '',
                    },
                };
                self.$emit('goToStep2', self.register, checkInviter);
            } else {
                if (!usernameVaild) {
                    self.registerStyle.username.error = true;
                    self.registerStyle.username.errmsg = self.$t('account_user_name_is_invaild');
                }
                if (!passwordVaild) {
                    if (!self.register.password || !self.register.repassword) {
                        self.registerStyle.password.error = true;
                        self.registerStyle.password.errmsg = self.$t('account_password_cannot_be_empty');
                    } else {
                        self.registerStyle.password.error = true;
                        self.registerStyle.password.errmsg = self.$t('account_password_not_satisfied');
                        self.registerStyle.repassword.error = true;
                        self.registerStyle.repassword.errmsg = self.$t('account_password_not_satisfied');
                    }
                }
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/ruc/registerStep1.js